module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ARTHUR, PRINCE OF WALES")])]), _vm._v(" "), _c('h1', {
    staticClass: "title1a"
  }, [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENRY")]), _vm._v(" VIII’s L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OST")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROTHER")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GARETH BENJAMIN STREETER")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/logo.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42429cfd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Title.vue
// module id = 63
// module chunks = 0